'use client';
import { type RefObject } from 'react';

import { useGridFilters } from '~features/gridFilters/hooks/useGridFilters';
import { useSession } from '~hooks/useSession';
import { gridApi } from '~services/api/grid';
import { isSafeApp } from '~shared/utils/host';

import { useScrollableBar } from '../../hooks/useScrollableBar';
import { OpenFiltersModalButton } from '../OpenFiltersModalButton';
import { SearchButton } from '../SearchButton';
import {
	ButtonsContainer,
	FiltersBarContainer,
	hiddenDesktop,
	hiddenMobile,
	MobileSearchBarWrapper,
	Separator,
	SFWWrapper,
	Wrapper,
} from './styles';

type Props = {
	children: React.ReactNode;
	exposed: boolean;
};

export const FiltersBar = ({ children, exposed }: Props) => {
	const { isDemoUser, isLoading: isSessionLoading } = useSession();
	const { filters } = useGridFilters();
	const { createdBy: _, ...restFilters } = filters;
	const filterCount = isSessionLoading
		? 0
		: Object.keys(!isDemoUser ? filters : restFilters).length;

	const { isLoading: isFiltersLoading } = gridApi.useGetGridFiltersQuery(
		undefined,
		{
			skip: exposed,
		}
	);

	const isLoading = !exposed && (isFiltersLoading || isSessionLoading);

	const { handleScroll, ref } = useScrollableBar();

	return (
		<>
			<MobileSearchBarWrapper className={hiddenDesktop}>
				<SearchButton />
			</MobileSearchBarWrapper>
			{isSafeApp && (
				<SFWWrapper className={hiddenMobile}>
					<SearchButton />
				</SFWWrapper>
			)}

			{!isSafeApp && (
				<Wrapper>
					<FiltersBarContainer
						ref={ref as RefObject<HTMLDivElement>}
						onScroll={handleScroll}
					>
						<ButtonsContainer>
							<SearchButton className={hiddenMobile} />
							<OpenFiltersModalButton
								skeleton={isLoading}
								count={filterCount}
							/>
							<Separator />
						</ButtonsContainer>

						{children}
					</FiltersBarContainer>
				</Wrapper>
			)}
		</>
	);
};
